import * as tslib_1 from "tslib";
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import { generateConsentString } from 'owa-gdpr-ad-consent-string';
import getOptions from '../selectors/getOptions';
import { trace } from 'owa-trace';
export default function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var options, consentString, savedOptions, newOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = getOptions();
                    return [4 /*yield*/, generateConsentString(options.allowAccess, options.allowPersonalization, options.allowAdSelection, options.allowContentSelection, options.allowMeasurement)];
                case 1:
                    consentString = _a.sent();
                    if (!consentString) {
                        trace.error('Generating consent string failed.');
                    }
                    savedOptions = getOptionsForFeature(OwsOptionsFeatureType.GdprAdsPrefs);
                    newOptions = tslib_1.__assign({}, savedOptions, { allowStorageAndAccess: options.allowAccess, allowAdSelectionDeliveryReporting: options.allowAdSelection, allowContentSelectionDeliveryReporting: options.allowContentSelection, allowPersonalization: options.allowPersonalization, allowMeasurement: options.allowMeasurement }, consentString ? { consentString: consentString } : null);
                    return [2 /*return*/, lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.GdprAdsPrefs, newOptions)];
            }
        });
    });
}
//# sourceMappingURL=commit.js.map